import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { crc32 } from 'crc'
import ElementLocale from 'element-ui/lib/locale'
Vue.use(VueI18n);

import cache from '../utils/cache'

import en from './json/en';
import zh_CN from './json/zh_CN';
// import zh_TW from './json/zh_TW';
import vi from './json/vi';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import zhTwLocale from 'element-ui/lib/locale/lang/zh-TW'
import viLocale from 'element-ui/lib/locale/lang/vi'
/*---------使用语言包-----------*/ 
const langKey = 'language'
const env = process.env.NODE_ENV

const _locale = cache.get(langKey) || window.locale || 'vi'

export const i18n = new VueI18n({
  locale: _locale, // 语言标识 
  messages: { 
    zh_CN: {
      ...zhLocale,
      ...zh_CN
    },//中文简体
    // zh_TW: {
    //   ...zhTwLocale,
    //   ...zh_TW
    // },
    vi: {
      ...viLocale,
      ...vi
    },
    en: {
      ...enLocale,
      ...en,
    }
  },
//   silentTranslationWarn: true,
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

const lang = (key, o) => {
  const hashKey = env !== 'production' ? `k${crc32(key).toString(16)}` : key;//production已经在外部用 crc.js 计算过了
  let words = i18n.t(hashKey, o)
  if (words === hashKey) {
    words = key
    // console.log(key, '-没翻译')
  }
  return words
}

// code 转换
export const langObj = {
  'zh-CN': 'zh_CN',
  'en-US': 'en',
  'vi-VN': 'vi'
}

export const changeLang = (key) => {
  key = langObj[key] || key
  cache.set(langKey, key)
  window.location.reload()
}

export const getHttpLang = () => {
  /* 
    越南
    Accept-Language:vi-VN,vi
    英语
    Accept-Language:en-US,en
    中文简体
    Accept-Language:zh-CN,zh
    中文繁体
    Accept-Language:zh-TW,zh
  */
  const locale = i18n.locale
  const strObj = {
    vi: 'vi-VN',
    en: 'en-US',
    zh_CN: 'zh-CN',
    zh_TW: 'zh-TW',
  }
  return strObj[locale] || locale
}
i18n.$t = lang

export default i18n